import { render, staticRenderFns } from "./UploadSimpackList.vue?vue&type=template&id=de6cf61c&"
import script from "./UploadSimpackList.vue?vue&type=script&lang=js&"
export * from "./UploadSimpackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports